import React, { useState, useEffect } from 'react';
import '../css/App.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import useIsPhone from '../Main/useIsPhone';
import Post from '../posts/post';
import Feedback from '../posts/feedback';
import { PROXY } from '../components/constants';
import TopBar from '../Bars/TopBar';
import SideBar from '../Bars/SideBar';


function Dashboard() {
  const [dateTime, setDateTime] = useState(new Date());
  const [totalClients, setTotalClients] = useState(0);
  const [totalRetainers, setTotalRetainers] = useState(0);
  const [totalCases, setTotalCases] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [showPost, setShowPost] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const isPhone = useIsPhone();
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setDateTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatDate = (date) => {
    const options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = date.toLocaleDateString(undefined, options);
    const day = formattedDate.split(',')[0];
    const remainingDate = formattedDate.split(',')[1].trim();
    return (
      <div className="text-2xl">
        <p className="text-5xl">{day.toUpperCase()}</p>
        <p className="">{remainingDate}, {date.getFullYear()}</p>
      </div>
    );
  };

  const formatTime = (date) => {
    let hours = date.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return (
      <div className="text-4xl font-mono">
        <p>{hours}:{minutes} {ampm}</p>
      </div>
    );
  };

  const [userData, setUserData] = useState(null);
  axios.defaults.withCredentials = true;

  // useEffect(() => {
  //   axios.get(`${PROXY}/session`)
  //     .then(res => {
  //       if (res.data.valid) {
  //         setUserData(res.data.userData);
  //         if (res.data.userData.account_type !== 1) {
  //           navigate('/');
  //         }
  //       } else {
  //         console.log(res.data)
  //         console.log("Redirecting to login page");
  //         navigate('/');
  //       }
  //     })
  //     .catch(err => console.log(err));
  // }, []);

  useEffect(() => {
    axios.get(`${PROXY}/totalclients`)
      .then(res => {
        setTotalClients(res.data.totalClients);
      })
      .catch(err => console.error("Error fetching total clients:", err));

    axios.get(`${PROXY}/totalretainers`)
      .then(res => {
        setTotalRetainers(res.data.totalRetainers);
      })
      .catch(err => console.error("Error fetching total retainers:", err));

    axios.get(`${PROXY}/totalcases`)
      .then(res => {
        setTotalCases(res.data.totalCases);
      })
      .catch(err => console.error("Error fetching total cases:", err));

    axios.get(`${PROXY}/totalusers`)
      .then(res => {
        setTotalUsers(res.data.totalUsers);
      })
      .catch(err => console.error("Error fetching total users:", err));
  }, []);


  return (
    <div className="flex flex-col md:flex-row h-screen pagescreen">
      <SideBar/>
      <div className="flex-1">
        <TopBar/>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-8" id='dashboardpage1'>
          <div className="boxdash w-full py-10 p-6 mb-4 rounded-lg">
            <p className="text-[20px] font-semibold mt-[-15px] border-b-[3px] border-white pb-2 text-center" style={{fontSize: isPhone ? '17px' : '20px' }}>Total Clients</p>
            <p className="dashnumber text-center text-[40px] mt-5 font-bold" style={{fontSize: isPhone ? '35px' : '40px' }}>{totalClients}</p>
          </div>
          <div className="boxdash w-full py-10 p-6 mb-4 rounded-lg">
            <p className="text-[20px] font-semibold mt-[-15px] border-b-[3px] border-white pb-2 text-center" style={{fontSize: isPhone ? '17px' : '20px' }}>Total Retainers</p>
            <p className="dashnumber text-center text-[40px] mt-5 font-bold" style={{fontSize: isPhone ? '35px' : '40px' }}>{totalRetainers}</p>
          </div>
          <div className="boxdash w-full py-10 p-6 mb-4 rounded-lg">
            <p className="text-[20px] font-semibold mt-[-15px] border-b-[3px] border-white pb-2 text-center" style={{fontSize: isPhone ? '17px' : '20px' }}>Total Cases</p>
            <p className="dashnumber text-center text-[40px] mt-5 font-bold" style={{fontSize: isPhone ? '35px' : '40px' }}>{totalCases}</p>
          </div>
          <div className="boxdash w-full py-10 p-6 mb-4 rounded-lg">
            <p className="text-[20px] font-semibold mt-[-15px] border-b-[3px] border-white pb-2 text-center" style={{fontSize: isPhone ? '17px' : '20px' }}>Total Users</p>
            <p className="dashnumber text-center text-[40px] mt-5 font-bold" style={{fontSize: isPhone ? '35px' : '40px' }}>{totalUsers}</p>
          </div>
        </div>

        <div className="text-center mt-10 sm:block hidden"
          onClick={() => setShowPost(!showPost)}>
          <div className="date-time-box cursor-pointer hover:bg-black hover:text-white">
            <p className="font-bold border-black text-[20px]">Make A Post</p>
          </div>
        </div>

        {showPost && (
          <Post/>
        )}

        <div className="text-center mt-10 sm:block hidden"
          onClick={() => setShowFeedback(!showFeedback)}>
          <div className="date-time-box cursor-pointer hover:bg-black hover:text-white">
            <p className="font-bold border-black text-[20px]">Check Feedback</p>
          </div>
        </div>

        {showFeedback && (
          <Feedback/>
        )}

        <div className="text-center mt-10 sm:block hidden">
          <div className="date-time-box">
            {formatDate(dateTime)}
            {formatTime(dateTime)}
            <p className="font-bold border-t-[2px] border-black text-[20px]">PHILIPPINES</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
